<template>
  <Flex class="flexColumn allAroundPadding white">
    <Flex class="fontSizeHalf bottomMargin">
      <Flex class="bold">
        Value sets
      </Flex>
      <Flex class="mainAxisFlexEnd grayText">
        <div class="pointer" @click="clear">
          Clear
        </div>
      </Flex>
    </Flex>
    <Flex class="bottomMarginHalf">
      <b-input size="is-small" class="fullWidth" placeholder="Search values" v-model="searchInput"/>
    </Flex>
    <!-- {{screen_sets}} -->
    <Flex :class="`topMargin ${set.is_template ? 'bold' : ''}`" v-for="set in filteredScreenSets" :key="set.id">
      <b-checkbox size="is-small" v-model="checkedScreenSetIds" :native-value="set.id" @input="debouncedSave">{{set.name}}</b-checkbox>
    </Flex>
  </Flex>
</template>

<script>
import Flex from '@frontend/components/Flex.vue';
import telemetry from '@frontend/api/Telemetry';

export default {
  data() {
    return {
      loading: false,
      active: false,
      screen_sets: [],
      checkedScreenSetIds: [],
      searchInput: '',
      debouncedSave: _.debounce(this.save, 250)
    };
  },
  components: { Flex },
  props: {
    // Other components can pass in values that are supplied separately that we don't want to return via the API, i.e.
    // deprecated personas. The additionalvalues array is then merged with the api response to provide a full list of
    // values for someone to choose from.
    additionalValues: Array,
    currentlyApplied: Array,
    callback: Function,
  },
  methods: {
    clear() {
      this.checkedScreenSetIds = [];
      this.save();
    },
    activate() {
      this.active = true;
    },
    save() {
      const toSave = this.screen_sets.filter(set => this.checkedScreenSetIds.includes(set.id));
      telemetry.track('Values Changed', {
        oldValues: this.currentlyApplied,
        newValues: toSave,
      });
      this.callback.call(this, toSave);
    },
  },
  computed: {
    filteredScreenSets() {
      if (!this.searchInput) {
        return this.screen_sets;
      }
      return this.screen_sets.filter(set => set.name.toLowerCase().indexOf(this.searchInput.toLowerCase()) >= 0);
    },
  },
  async created() {
    this.loading = true;
    let screenSetEndpointData = await fetch('/api/v1/screen_sets/');
    screenSetEndpointData = await screenSetEndpointData.json();
    this.screen_sets = [...screenSetEndpointData.screen_sets];
    this.checkedScreenSetIds = this.currentlyApplied.map(set => set.id);
    this.loading = false;
  },
};
</script>

<style lang="scss">
</style>
